import { ParsedUrlQuery, ParsedUrlQueryInput } from "querystring";
import { FiltersQuery } from "../types/FilterQuery.interface";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

export interface UseQueryProps {
  push: (
    querys: string | ParsedUrlQueryInput | null | undefined | FiltersQuery
  ) => void;

  query: FiltersQuery | ParsedUrlQuery;

  Item: React.FC<ItemProps>;
}

interface ItemProps {
  children: (query: ParsedUrlQuery | FiltersQuery) => React.ReactElement;
}

const useQuery = (initQuery: FiltersQuery): UseQueryProps => {
  const router = useRouter();
  const [query, setQuery] = useState<FiltersQuery | ParsedUrlQuery>(initQuery);

  useEffect(() => {
    setQuery(router.query);
  }, [router.query]);

  const push = (
    querys: string | ParsedUrlQueryInput | null | undefined | FiltersQuery
  ) => {
    router.push({
      pathname: router.asPath.split("?")[0],
      query: Object.assign(query, querys) as ParsedUrlQuery,
    });
  };

  const Item: React.FC<ItemProps> = (props) => {
    return props.children(query);
  };

  return {
    push,
    query,
    Item,
  };
};

export default useQuery;
